/*eslint no-script-url: 0 */
import React, { Component } from "react";
import { Tab, Nav, NavItem } from 'react-bootstrap';
import Constants from './Config/Config';
import Parser from 'html-react-parser';
import {Loader} from './Helpers/Helpers';

class AdditionalInfo extends Component {

	constructor(props) {
        super(props)
        this.state = {
			content: null,
		}
    }

	fetchModuleContent() {
		var self = this;
		fetch(Constants.URL.root+'/wp-json/acf/v2/options')
		.then(response => {
			if (!response.ok) {
				throw Error('Network request failed.')
			}
			return response;
		})
			.then(data => data.json())
			.then(data => {
				//console.log(data);
				self.setState({ content: data })
			}, (ex) => {
			})
	}

	componentDidMount() {
		this.fetchModuleContent();
	}

  	render() {
		const { content } = this.state;
	    return (
	    	<div className="frame_desc full_width">
				<div className="container">
					<div className="row">
						<div className="col-sm-12">
							<Tab.Container defaultActiveKey="faqs" id="tab-container-info">
								<div>
									<div className="top_tab_nav">
										<Nav bsStyle="tabs">
											<NavItem eventKey="faqs">How to Order/FAQS</NavItem>
											<NavItem eventKey="description">Product Description</NavItem>
											<NavItem eventKey="shipping">Shipping & Returns</NavItem>
										</Nav>
									</div>
									<div className="top_tab_cont">
										<Tab.Content>
 											<Tab.Pane eventKey="faqs">
												{content ? Parser(content.acf.content_mat_customizer.how_to_order) : <Loader/>}
									        </Tab.Pane>
									       	<Tab.Pane eventKey="description">
												{content ? Parser(content.acf.content_mat_customizer.product_description) : <Loader/>}
									        </Tab.Pane>
									        <Tab.Pane eventKey="shipping">
									       		{content ? Parser(content.acf.content_mat_customizer.shipping_returns) : <Loader/>}
									        </Tab.Pane>
									    </Tab.Content>
									</div>
								</div>
							</Tab.Container>
						</div>
					</div>
				</div>
			</div>
	    );
  	}
}

export default AdditionalInfo;